// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SiteHeaderFrame-module__frame__uBRfM {
  display: block;
  width: 100%;
  border: 0;
  /* The embed page paints on a transparent background, so the page colour
     shows through and there is no seam against the form. */
  background: transparent;
  /* The header is decoration: it must never intercept the form's own scroll. */
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/features/site-header/SiteHeaderFrame.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT;2DACyD;EACzD,uBAAuB;EACvB,6EAA6E;EAC7E,gBAAgB;AAClB","sourcesContent":[".frame {\n  display: block;\n  width: 100%;\n  border: 0;\n  /* The embed page paints on a transparent background, so the page colour\n     shows through and there is no seam against the form. */\n  background: transparent;\n  /* The header is decoration: it must never intercept the form's own scroll. */\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `SiteHeaderFrame-module__frame__uBRfM`
};
module.exports = ___CSS_LOADER_EXPORT___;
